// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Cgnh","obliqueLineWrap":"membershipbadge_obliqueLineWrap___63VU","obliqueLine":"membershipbadge_obliqueLine__3m3gT"};